"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { LatestNews } from "./latest-news";
import { PressReleases } from "./press-releases";
import { MediaCoverage } from "./media-coverage";
import { IndustryRecognition } from "./industry-recognition";
import { AnalystCoverage } from "./analyst-coverage";
import { ThoughtLeadership } from "./thought-leadership";
import { ConferencesEvents } from "./conferences-events";
import { MediaKit } from "./media-kit";
import { ExecutiveProfile } from "./executive-profile";
import { CompanyMilestones } from "./company-milestones";
import { IndustryAwards } from "./industry-awards";
import { PublicationsResearch } from "./publications-research";
import { PodcastInterviews } from "./podcast-interviews";
import { PressContact } from "./press-contact";
import { PressCta } from "./cta";
import { AboutPx } from "./about-px";

export function PressPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <ExecutiveSummary />
      </div>
      <LatestNews />
      <div className="bg-aurora-purple">
        <PressReleases />
      </div>
      <MediaCoverage />
      <div className="bg-aurora-cyan">
        <IndustryRecognition />
      </div>
      <AnalystCoverage />
      <div className="bg-aurora-emerald">
        <ThoughtLeadership />
      </div>
      <ConferencesEvents />
      <div className="bg-aurora-amber">
        <MediaKit />
      </div>
      <ExecutiveProfile />
      <div className="bg-aurora-crimson">
        <CompanyMilestones />
      </div>
      <IndustryAwards />
      <div className="bg-aurora-purple">
        <PublicationsResearch />
      </div>
      <PodcastInterviews />
      <div className="bg-aurora-cyan">
        <PressContact />
      </div>
      <PressCta />
      <AboutPx />
    </>
  );
}
